// extracted by mini-css-extract-plugin
module.exports = {"registerBtn":"__registerBtn___9Lg_","formField":"__formField__e7GMH","formFieldCheckbox":"__formFieldCheckbox__qELQX"};